<template>
  <div>
    <headerSection></headerSection>

    <!-- Main Container -->
    <div class="continue-page">
      <!-- Hero Section -->
      <div class="hero-section">
        <!-- Floating Balls -->
        <div class="floating-ball ball-1"></div>
        <div class="floating-ball ball-2"></div>
        <div class="floating-ball ball-3"></div>

        <div class="container">
          <div class="hero-content">
            <!-- Icon with bounce animation -->
            <div class="hero-icon-wrapper">
              <span class="hero-icon">🔥</span>
            </div>

            <!-- Title with glow -->
            <h1 class="title-glow">{{ $t('continue_page.title') }}</h1>

            <!-- Description -->
            <p class="hero-description">{{ $t('continue_page.title4') }}</p>
          </div>
        </div>
      </div>

      <!-- Content Section -->
      <div class="container content-section">
        <!-- Current Status Cards -->
        <div class="status-cards">
          <!-- Promotion Name Card -->
          <div class="status-card glass-card">
            <div class="status-label">{{ $t('continue_page.title2') }}</div>
            <div class="status-value">
              {{ (continues && continues.promotion) ? continues.promotion.name : $t('continue_page.title2') }}
            </div>
          </div>

          <!-- Bonus Amount Card -->
          <div class="status-card glass-card">
            <div class="status-icon">💰</div>
            <div class="status-label">{{ $t('continue_page.title3') }}</div>
            <div class="status-value">{{ numberWithCommas(continues.total) }}</div>
          </div>
        </div>

        <!-- 7-Day Progress Tracker -->
        <div class="tracker-card glass-card">
          <div class="tracker-header">
            <span class="tracker-title">{{ $t('continue_page.title2') }}</span>
          </div>

          <div class="days-grid">
            <div
              v-for="(day, index) in 7"
              :key="index"
              class="day-item"
              :class="{ 'active': dots[index] }"
            >
              <div class="day-circle">
                <span v-if="dots[index]" class="day-check">✓</span>
                <span v-else class="day-number">{{ index + 1 }}</span>
              </div>
              <div class="day-label">{{ $t('day') }} {{ index + 1 }}</div>
            </div>
          </div>

          <!-- Progress Bar -->
          <div class="progress-section">
            <div class="progress-bar">
              <div
                class="progress-fill"
                :style="{ width: `${(dots.length / 7) * 100}%` }"
              ></div>
            </div>
            <div class="progress-label">
              {{ dots.length }} / 7 {{ $t('days_completed') }}
            </div>
          </div>
        </div>

        <!-- Claim Button -->
        <div class="claim-button-wrapper">
          <button
            @click="moveContinuesToWallet()"
            class="claim-btn btn-primary"
            :class="{ 'disabled': !(continues && continues.total > 0) }"
            :disabled="!(continues && continues.total > 0)"
          >
            <span class="claim-btn-icon">🎁</span>
            <span class="claim-btn-text">{{ $t('partner_title7') }}</span>
          </button>
        </div>

        <!-- Rules Section -->
        <div class="rules-card glass-card">
          <div class="rules-header">
            <span class="rules-icon">📋</span>
            <span class="rules-title">{{ $t('rules_title') }}</span>
          </div>

          <div class="rules-list">
            <div class="rule-item">
              <span class="rule-bullet">•</span>
              <span class="rule-text">{{ $t('continue_page.rules.member_7_days') }}</span>
            </div>

            <div class="rule-item highlight">
              <span class="rule-bullet">✨</span>
              <span class="rule-text">{{ $t('continue_page.rules.deposit_1000_bonus') }}</span>
            </div>

            <div class="rule-item highlight">
              <span class="rule-bullet">✨</span>
              <span class="rule-text">{{ $t('continue_page.rules.deposit_2000_bonus') }}</span>
            </div>

            <div class="rule-item highlight">
              <span class="rule-bullet">✨</span>
              <span class="rule-text">{{ $t('continue_page.rules.deposit_3000_bonus') }}</span>
            </div>

            <div class="rule-item">
              <span class="rule-bullet">•</span>
              <span class="rule-text">{{ $t('continue_page.rules.no_bonus_deposit') }}</span>
            </div>

            <div class="rule-item">
              <span class="rule-bullet">•</span>
              <span class="rule-text">{{ $t('continue_page.rules.casino_games_only') }}</span>
            </div>

            <div class="rule-item">
              <span class="rule-bullet">•</span>
              <span class="rule-text">{{ $t('continue_page.rules.no_feature_buy') }}</span>
            </div>

            <div class="rule-item">
              <span class="rule-bullet">•</span>
              <span class="rule-text">{{ $t('continue_page.rules.no_exceed_bonus') }}</span>
            </div>

            <div class="rule-item">
              <span class="rule-bullet">•</span>
              <span class="rule-text">{{ $t('continue_page.rules.withdraw_3x') }}</span>
            </div>

            <div class="rule-item">
              <span class="rule-bullet">•</span>
              <span class="rule-text">{{ $t('continue_page.rules.max_withdraw_3x') }}</span>
            </div>

            <div class="rule-item">
              <span class="rule-bullet">•</span>
              <span class="rule-text">{{ $t('continue_page.rules.bonus_credit_only') }}</span>
            </div>

            <div class="rule-item">
              <span class="rule-bullet">•</span>
              <span class="rule-text">{{ $t('continue_page.rules.credit_below_10') }}</span>
            </div>

            <div class="rule-item">
              <span class="rule-bullet">•</span>
              <span class="rule-text">{{ $t('continue_page.rules.auto_claim_time') }}</span>
            </div>

            <div class="rule-item warning">
              <span class="rule-bullet">⚠</span>
              <span class="rule-text">{{ $t('continue_page.rules.violation_warning') }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <footerSection></footerSection>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/database'
import moment from 'moment-timezone'
import router from './../router'
const axios = require('axios').default
export default {
  name: 'continues',
  components: {
    headerSection: () => import('./Header.vue'),
    footerSection: () => import('./Footer.vue')
  },
  data: function () {
    return {
      continues: [],
      dots: [],
      disabled: false
    }
  },
  computed: {
    user () {
      return this.$store.state.user.user
    }
  },
  methods: {
    scrollToTop () {
      window.scrollTo(0, 0)
    },
    moveContinuesToWallet () {
      if (this.continues.total && this.continues.key && !this.disabled) {
        this.disabled = true;
        this.$store.commit('user/SET_LOADING', true)
        this.$store.dispatch('user/moveCreditToWallet').finally((res) => {
          setTimeout(async () => {
            const eligibility = await this.$store.dispatch('user/checkBonusClaimEligibility', { type: 'continuous' })
            if (eligibility.blocked) {
              this.showBonusClaimBlockedAlert(eligibility)
              this.$store.commit('user/SET_LOADING', false)
              return
            }

            let check = false
            await firebase.firestore().collection('history').where('userkey', '==', this.user.key).where('status', 'not-in', ['ดำเนินการแล้ว', 'ยกเลิก']).where('type', '==', 'ถอน').limit(1).get().then((result) => {
              if (result.size) {
                check = true
              }
            })
            if (!check) {
              axios.get(`https://api.connextcc.cc/qcontinuous/continuous/${this.continues.key}`)
              setTimeout(() => {
                this.getContinues()
                this.$store.commit('user/SET_LOADING', false)
              }, 2000)
            } else {
              this.$swal({ icon: 'error', title: this.$t('partner_page.alert_title'), text: this.$t('continue_page.alert_wait_withdraw') })
              this.$store.commit('user/SET_LOADING', false)
            }
          }, 2000)
        }).catch(err => { console.error(err) })
        setTimeout(() => {
          this.disabled = false;
        }, 3000);
      }
    },
    showBonusClaimBlockedAlert (eligibility) {
      const total = Number(eligibility.promotionBalanceTotal || eligibility.totalBalance || 0).toFixed(2)
      const limit = Number(eligibility.limit || 10).toFixed(2)
      const lineLink = this.$store.getters['settings/adminContactLineLink'] || this.$store.getters['settings/linkLine'] || 'https://lin.ee/xalM4XE'
      return this.$swal({
        icon: 'error',
        title: 'เงื่อนไข',
        html: `ต้องมียอดคงเหลือรวมต่ำกว่า ${limit} บาท ถึงรับได้ค่ะ (ยอดรวมปัจจุบัน ${total} บาท)<br><br>สอบถามข้อมูลเครดิตเพิ่มเติม กรุณาติดต่อแอดมิน`,
        showCancelButton: true,
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ติดต่อแอดมิน',
        reverseButtons: false
      }).then((swalResult) => {
        if (swalResult && swalResult.dismiss === 'cancel' && lineLink) {
          window.open(lineLink, '_blank')
        }
        return swalResult
      })
    },
    checkStyle () {
      if (this.continues && this.continues.total > 0) {
        return 'background: linear-gradient(180deg,#fbc844,#f88012);height: 43px;min-width:120px;padding-left: 24px;padding-right: 24px;padding-top: 0.8em;'
      } else {
        return 'background: linear-gradient(180deg,#cccccc,#cccccc);height: 43px;min-width:120px;padding-left: 24px;padding-right: 24px;padding-top: 0.8em;'
      }
    },
    numberWithCommas (x) {
	  if (!x) x = 0
      return x.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    getUserId () {
      const user = localStorage.getItem('userData')
      if (user) {
        const _user = JSON.parse(user)
        return _user
      } else {
        firebase.auth().signOut()
        localStorage.removeItem('userData')
        router.replace('/login')
      }
    },
    async getContinues () {
      const user = this.getUserId()
      if (user) {
        await firebase.firestore().collection('continuous_deposit').where('date', '==', moment().tz('Asia/Bangkok').add(-1, 'days').format('YYYY-MM-DD')).where('userkey', '==', user.key).where('status', '==', false).get().then((snapshot) => {
          if (!snapshot.size) {
            this.continues = []
            this.dots = []
          }
          snapshot.forEach((doc) => {
            const data = doc.data()
            data.key = doc.id
            this.continues = data
          })
        })
        // if (this.continues && this.continues.promotion) {
        //   for (let i = 0; i < Number(this.continues.promotion.numday); i++) {
        //     this.dots.push(true)
        //   }
        // } else {
          const fixed = 1000
          let last = {}
          await firebase.firestore().collection('continuous_deposit_all').where('userkey', '==', user.key).where('status', '==', true).orderBy('date', 'desc').limit(1).get().then((snapshot) => {
            snapshot.forEach((doc) => {
              const data = doc.data()
              data.key = doc.id
              last = data
            })
          })
          const dateCheck = []
          if (last && last.date) {
            await firebase.firestore().collection('daily_deposit').where('createdate', '>', last.date).where('createdate', '<=', moment().tz('Asia/Bangkok').add(-1, 'days').format('YYYY-MM-DD')).where('userkey', '==', user.key).orderBy('createdate', 'desc').limit(7).get().then((snapshot) => {
              snapshot.forEach((doc) => {
                if (doc.data().total >= fixed) {
                  dateCheck[doc.data().createdate] = true
                }
              })
            })
          } else {
            await firebase.firestore().collection('daily_deposit').where('createdate', '<=', moment().tz('Asia/Bangkok').add(-1, 'days').format('YYYY-MM-DD')).where('userkey', '==', user.key).orderBy('createdate', 'desc').limit(7).get().then((snapshot) => {
              snapshot.forEach((doc) => {
                if (doc.data().total >= fixed) {
                  dateCheck[doc.data().createdate] = true
                }
              })
            })
          }
          if (dateCheck) {
            for (let i = 1; i <= 7; i++) {
              if (dateCheck[moment().tz('Asia/Bangkok').add(-i, 'days').format('YYYY-MM-DD')]) {
                this.dots.push(true)
              } else {
                break
              }
            }
          // }
        }
      }
    }
  },
  mounted () {
    this.scrollToTop()
    this.getContinues()
  }
}
</script>

<style scoped>
/* Page Background */
.continue-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #2b2727 0%, #1b1b1b 50%, #2b2727 100%);
  padding-bottom: 100px;
}

/* Hero Section */
.hero-section {
  position: relative;
  padding: 80px 0 30px;
  overflow: hidden;
  background: linear-gradient(180deg, rgba(247, 178, 66, 0.1) 0%, transparent 100%);
}

.hero-content {
  position: relative;
  z-index: 2;
  text-align: center;
  max-width: 600px;
  margin: 0 auto;
  padding: 0 20px;
}

.hero-icon-wrapper {
  display: inline-block;
  margin-bottom: 20px;
  animation: bounce 2s ease-in-out infinite;
}

.hero-icon {
  font-size: 64px;
  display: block;
  filter: drop-shadow(0 4px 15px rgba(247, 178, 66, 0.4));
}

@keyframes bounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
}

.title-glow {
  font-size: 36px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 15px;
  text-shadow:
    0 0 20px rgba(247, 178, 66, 0.5),
    0 0 40px rgba(247, 178, 66, 0.3),
    0 2px 4px rgba(0, 0, 0, 0.5);
}

.hero-description {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.6;
  font-family: 'Kanit', sans-serif;
}

/* Floating Balls */
.floating-ball {
  position: absolute;
  border-radius: 50%;
  opacity: 0.15;
  pointer-events: none;
  z-index: 1;
}

.floating-ball.ball-1 {
  width: 200px;
  height: 200px;
  background: linear-gradient(135deg, #f7b242, #ce840c);
  top: -50px;
  left: -100px;
  animation: float1 6s ease-in-out infinite;
}

.floating-ball.ball-2 {
  width: 150px;
  height: 150px;
  background: linear-gradient(135deg, #ce840c, #f7b242);
  top: 50%;
  right: -75px;
  animation: float2 8s ease-in-out infinite;
}

.floating-ball.ball-3 {
  width: 100px;
  height: 100px;
  background: linear-gradient(135deg, #2b2727, #f7b242);
  bottom: 20%;
  left: 10%;
  animation: float3 7s ease-in-out infinite;
}

@keyframes float1 {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  50% { transform: translate(30px, 20px) rotate(180deg); }
}

@keyframes float2 {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  50% { transform: translate(-20px, 30px) rotate(-180deg); }
}

@keyframes float3 {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  50% { transform: translate(20px, -20px) rotate(180deg); }
}

/* Content Section */
.content-section {
  padding: 30px 20px;
  max-width: 800px;
  margin: 0 auto;
}

/* Glass Card Effect */
.glass-card {
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(247, 178, 66, 0.2);
  border-radius: 12px;
  padding: 20px;
  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.3),
    0 0 20px rgba(247, 178, 66, 0.1);
  transition: all 0.3s ease;
}

.glass-card:hover {
  border-color: rgba(247, 178, 66, 0.3);
  box-shadow:
    0 12px 40px rgba(0, 0, 0, 0.4),
    0 0 30px rgba(247, 178, 66, 0.15);
}

/* Status Cards */
.status-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.status-card {
  text-align: center;
  padding: 20px;
  position: relative;
}

.status-icon {
  font-size: 32px;
  margin-bottom: 10px;
  filter: drop-shadow(0 2px 8px rgba(247, 178, 66, 0.3));
}

.status-label {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 8px;
  font-family: 'Kanit', sans-serif;
}

.status-value {
  font-size: 20px;
  font-weight: 600;
  color: #f7b242;
  text-shadow: 0 0 15px rgba(247, 178, 66, 0.4);
  font-family: 'Kanit', sans-serif;
}

/* Tracker Card */
.tracker-card {
  margin-bottom: 30px;
  padding: 30px 20px;
}

.tracker-header {
  text-align: center;
  margin-bottom: 25px;
}

.tracker-title {
  font-size: 20px;
  font-weight: 600;
  color: #f7b242;
  font-family: 'Kanit', sans-serif;
  text-shadow: 0 0 15px rgba(247, 178, 66, 0.3);
}

/* Days Grid */
.days-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 15px;
  margin-bottom: 25px;
}

.day-item {
  text-align: center;
}

.day-circle {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  border: 2px solid rgba(247, 178, 66, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 8px;
  font-size: 16px;
  color: rgba(255, 255, 255, 0.5);
  transition: all 0.3s ease;
  font-family: 'Kanit', sans-serif;
}

.day-item.active .day-circle {
  background: linear-gradient(135deg, #f7b242, #ce840c);
  border-color: #f7b242;
  box-shadow: 0 0 20px rgba(247, 178, 66, 0.5);
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.05); }
}

.day-check {
  color: #fff;
  font-weight: 700;
  font-size: 24px;
}

.day-number {
  color: rgba(255, 255, 255, 0.5);
  font-weight: 600;
}

.day-item.active .day-number {
  color: #fff;
}

.day-label {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  font-family: 'Kanit', sans-serif;
}

.day-item.active .day-label {
  color: #f7b242;
  font-weight: 600;
}

/* Progress Section */
.progress-section {
  margin-top: 20px;
}

.progress-bar {
  width: 100%;
  height: 10px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 10px;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #f7b242, #ce840c);
  border-radius: 10px;
  transition: width 0.5s ease;
  box-shadow: 0 0 10px rgba(247, 178, 66, 0.5);
}

.progress-label {
  text-align: center;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  font-family: 'Kanit', sans-serif;
}

/* Buttons */
.btn-primary {
  background: linear-gradient(135deg, #f7b242, #ce840c);
  border: none;
  border-radius: 8px;
  padding: 12px 30px;
  color: #fff;
  font-weight: 600;
  font-size: 16px;
  font-family: 'Kanit', sans-serif;
  box-shadow:
    0 4px 15px rgba(247, 178, 66, 0.3),
    0 2px 5px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow:
    0 6px 20px rgba(247, 178, 66, 0.4),
    0 3px 8px rgba(0, 0, 0, 0.3);
  filter: brightness(1.1);
}

.btn-primary:active {
  transform: translateY(0);
}

.btn-primary.disabled,
.btn-primary:disabled {
  background: linear-gradient(135deg, #666, #444);
  cursor: not-allowed;
  box-shadow: none;
  opacity: 0.6;
}

.btn-primary.disabled:hover,
.btn-primary:disabled:hover {
  transform: none;
  filter: none;
}

/* Claim Button */
.claim-button-wrapper {
  text-align: center;
  margin-bottom: 30px;
}

.claim-btn {
  min-width: 200px;
}

.claim-btn-icon {
  font-size: 20px;
}

.claim-btn-text {
  font-size: 14px;
}

/* Rules Card */
.rules-card {
  padding: 25px;
}

.rules-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid rgba(247, 178, 66, 0.2);
}

.rules-icon {
  font-size: 28px;
}

.rules-title {
  font-size: 20px;
  font-weight: 600;
  color: #f7b242;
  font-family: 'Kanit', sans-serif;
}

.rules-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.rule-item {
  display: flex;
  gap: 10px;
  padding: 10px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.02);
  transition: all 0.3s ease;
}

.rule-item:hover {
  background: rgba(247, 178, 66, 0.05);
}

.rule-item.highlight {
  background: rgba(247, 178, 66, 0.1);
  border-left: 3px solid #f7b242;
}

.rule-item.warning {
  background: rgba(255, 100, 100, 0.1);
  border-left: 3px solid #ff6464;
}

.rule-bullet {
  font-size: 16px;
  color: #f7b242;
  flex-shrink: 0;
}

.rule-item.warning .rule-bullet {
  color: #ff6464;
}

.rule-text {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.6;
  font-family: 'Kanit', sans-serif;
}

/* Responsive Design */
@media screen and (max-width: 768px) {
  .hero-section {
    padding: 75px 0 25px;
  }

  .title-glow {
    font-size: 28px;
  }

  .hero-icon {
    font-size: 48px;
  }

  .floating-ball.ball-1 {
    width: 150px;
    height: 150px;
  }

  .floating-ball.ball-2 {
    width: 100px;
    height: 100px;
  }

  .floating-ball.ball-3 {
    width: 80px;
    height: 80px;
  }

  .status-cards {
    grid-template-columns: 1fr;
    gap: 15px;
  }

  .days-grid {
    grid-template-columns: repeat(7, 1fr);
    gap: 8px;
  }

  .day-circle {
    width: 40px;
    height: 40px;
    font-size: 14px;
  }

  .day-check {
    font-size: 20px;
  }

  .day-label {
    font-size: 10px;
  }

  .rule-text {
    font-size: 14px;
  }
}

@media screen and (max-width: 480px) {
  .hero-section {
    padding: 70px 0 20px;
  }

  .title-glow {
    font-size: 24px;
  }

  .hero-description {
    font-size: 14px;
  }

  .hero-icon {
    font-size: 40px;
  }

  .content-section {
    padding: 20px 15px;
  }

  .glass-card {
    padding: 15px;
  }

  .btn-primary {
    padding: 10px 20px;
    font-size: 14px;
  }

  .days-grid {
    gap: 5px;
  }

  .day-circle {
    width: 35px;
    height: 35px;
    font-size: 12px;
  }

  .day-check {
    font-size: 18px;
  }

  .day-label {
    font-size: 9px;
  }

  .tracker-card {
    padding: 20px 15px;
  }

  .rules-card {
    padding: 20px 15px;
  }

  .rule-text {
    font-size: 13px;
  }

  .rule-bullet {
    font-size: 14px;
  }
}
</style>
